import { ImageSelectMenu } from "#common";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { get } from "#api";

function FosterDropdown({ animal, onChange }) {
  const query = useQuery({
    queryKey: ["fosters"],
    queryFn: () => get(`/user/fosters`),
    initialData: [],
  });
  const handleChange = (v) => {
    onChange({
      target: {
        name: "userId",
        value: v,
      },
    });
  };
  return (
    <ImageSelectMenu
      items={query.data}
      selected={animal?.userId}
      setSelected={handleChange}
    />
  );
}
export default FosterDropdown;
